import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { useTranslation } from "react-i18next";
import to from "await-to-js";
import cn from "clsx";
import style from "./index.module.scss";
// 组件
import CDNImage from "@/components/cdnImage/cdnImage";
import { cancelAfsRecord } from "@/app/csr-src/apis/afterSales/afterSales.api";
import CommonButton from "@/app/csr-src/pages/order/components/commonButton";
import UKToast from "@/common-components-src/components/UKToast/index";
import LocationModal from "@/app/csr-src/pages/order/components/locationModal";
import ViewImage from "@/components/viewImage";
import AfsTrackModal from "../afsTrackModal";
// 接口
import { ICancelRecordReq, AfsServiceDetailVo, AfsServiceProcessNodeVo } from "@/app/csr-src/apis/afterSales/afterSales.interface";
// utils
import { useFileSaver } from "@/utils/saveFile";

// 图标
import CompetedIcon from "@/assets/icons/CompetedIcon.svg";
import StepErrorIcon from "@/assets/icons/StepErrorIcon.svg";
import Expand from "@/app/csr-src/assets/icons/chevron-down.svg";
interface statusAreaProps {
  afsDetailInfo: AfsServiceDetailVo;
  afsProcessNode: AfsServiceProcessNodeVo;
  onRefresh?: () => void;
}

const AfterSalesAccordion = ({ afsDetailInfo, afsProcessNode, onRefresh }: statusAreaProps) => {
  const { t } = useTranslation();
  const {
    allowCancel, //是否显示取消售后按钮
    afsServiceId,
    refundAmountStr, //退款金额（判断是否展示退款金额模块）
    applyDate,
    afsServiceStatus,
    returnModel,
    showWaybill,
  } = afsDetailInfo || {};
  const { nodeCodeI18nKey, nodeContentI18nKey, nodeStatusList } = afsProcessNode || {};
  // 当前节点数据
  const curStepItem = nodeStatusList?.filter((item: any) => item.type === 2)?.[0] || {};

  // type 1为已完成，对号样式，2为当前状态，红底白字，3为未到达状态，白底黑字，4为已拒绝或者已取消状态，叉号样式
  const [progressList, setProgressList] = useState<any>([]);
  const [isEditPickUpTime, setIsEditPickUpTime] = useState<boolean>(false);
  const [curLocationInfo, setCurLocationInfo] = useState<any>(curStepItem?.stateDTO);
  const [againCancel, setAgainCancel] = useState(false); //是否展示二次确认弹窗
  const [showLocationModal, setShowLocationModal] = useState(false); // 展示驿站地图弹框
  const [isOpenReviewImage, setIsOpenReviewImage] = useState<boolean>(false);
  const [showTrackModal, setShowTrackModal] = useState(false);
  const { saveFile } = useFileSaver();

  //保存修改的pickup时间
  const savePickUp = () => {
    setIsEditPickUpTime(false);
  };

  // 取消售后
  const cancelRequestHandler = async () => {
    setAgainCancel(false);
    const requestData: ICancelRecordReq = { afsServiceId };
    const [err, cancelAfsRecordData] = await to(cancelAfsRecord(requestData));

    if (err) {
      UKToast.show({
        content: t("afterSales.statusArea.cancelFailTips"), // 弹窗内容
        icon: "warning", // 可选：success, fail, loading, warn, info，影响图标
        duration: 2000, // 不写的话默认3000
      });
    } else {
      if (parseFloat(cancelAfsRecordData?.code) === 200 && cancelAfsRecordData?.success) {
        UKToast.show({
          content: t("afterSales.statusArea.cancelSuccessTips"), // 弹窗内容
          icon: "success", // 可选：success, fail, loading, warn, info，影响图标
          duration: 2000, // 不写的话默认3000
        });
        setTimeout(() => {
          onRefresh && onRefresh();
        }, 2000);
      } else {
        UKToast.show({
          content: t("afterSales.statusArea.cancelFailTips"), // 弹窗内容
          icon: "warning", // 可选：success, fail, loading, warn, info，影响图标
          duration: 2000, // 不写的话默认3000
        });
      }
    }
  };

  //下载二维码
  const downloadHandler = (url: string, type: string) => {
    url && saveFile(url, type);
  };

  // 选择驿站回调
  const locationChangeHandler = (val: any) => {
    setShowLocationModal(false);
    setCurLocationInfo(val);
  };
  useEffect(() => {
    const reversedArr = [...nodeStatusList.filter((x) => x.type !== 3)].reverse() || [];
    // const reversedArr = [...mockNodeStatusList].reverse() || [];
    console.log("sxt-reversedArr", reversedArr);
    setProgressList(reversedArr);
  }, [nodeStatusList]);

  // item.type
  // 1-走过的节点状态 展示红色对钩
  // 2-当前节点状态  展示红色数字
  // 3-未到达的节点状态 展示白色数字
  // 4-中断类型（拒绝、驳回、取消节点使用 优先级最高）展示红叉

  if (progressList.length > 0) {
    return (
      <div className={style.afterSalesTrajectory_wrap}>
        {progressList.map((item: any, index: number) => {
          return (
            <div className={style.trajectoryItem} key={item.order}>
              <div className={style.title}>
                <div className={`${style.titleText} ${index === 0 ? style.expanded : ""}`}>
                  {item.type === 1 ? (
                    <CompetedIcon className={style.competedIcon} color="#CC0C1C" width={18} height={18} />
                  ) : item.type === 4 ? (
                    <StepErrorIcon className={style.competedIcon} color="#CC0C1C" width={18} height={18} />
                  ) : (
                    <div className={style.activeIcon}>{item.order}</div>
                  )}
                  <span>{item.subText}</span>
                </div>
                {allowCancel && index === 0 && (
                  <CommonButton variant="outlined" onClick={() => setAgainCancel(true)}>
                    Withdraw
                  </CommonButton>
                )}
                {showWaybill && index === 0 && (
                  <CommonButton variant="outlined" onClick={() => setShowTrackModal(true)}>
                    Track logistic
                  </CommonButton>
                )}
                {/* 有按钮的时候不展示时间 */}
                {!((allowCancel || showWaybill) && index === 0) && item.stepTime && <div className={style.date}>{item.stepTime}</div>}
              </div>
              {item.desc && <div className={style.content}>{item.desc}</div>}
              {item.type === 2 ? (
                <>
                  {/* 节点return会有以下两种场景drop-off和pick-up */}
                  {returnModel === 70 ? (
                    <>
                      {item.qrcode || curLocationInfo ? (
                        <div className={style.returnDropOff}>
                          {curLocationInfo ? (
                            <div className={style.left}>
                              <div className={style.leftTitle}>
                                <span>{curLocationInfo.postHouseName}</span>
                                {/* <span style={{ display: "inline-block", marginLeft: "16px" }}>{curLocationInfo.distance}mi</span> */}
                                {item.showPosthouseBtn && (
                                  <span
                                    className={style.changeBtn}
                                    onClick={() => {
                                      setShowLocationModal(true);
                                    }}
                                  >
                                    Change
                                    <Expand className={style.entryIco} />
                                  </span>
                                )}
                              </div>
                              <div className={style.leftAdd}>{curLocationInfo.address}</div>
                              {!!curLocationInfo.businessHours.length && (
                                <ul className={style.openingTime}>
                                  <li className={style.openingTimeLi}>openingTime</li>
                                  {curLocationInfo.businessHours &&
                                    curLocationInfo.businessHours.length > 0 &&
                                    curLocationInfo.businessHours.map((x: any) => {
                                      return (
                                        <li className={style.openingTimeLi} key={x.sortIndex}>
                                          <span>{x.title}</span>
                                          <span>{x.subTitle}</span>
                                        </li>
                                      );
                                    })}
                                </ul>
                              )}
                            </div>
                          ) : null}
                          {item.qrcode ? (
                            <div className={style.right}>
                              <div
                                className={style.qrImage}
                                onClick={() => {
                                  setIsOpenReviewImage(true);
                                }}
                              >
                                <CDNImage width={160} height={160} src={item.qrcode} />{" "}
                              </div>

                              <div className={style.qrTips}>
                                <span className={style.qrText}>{item.qrCodeText}</span>
                                <div className={style.qrDownload} onClick={() => downloadHandler(item.qrcode || "", "image")}>
                                  Download QR code
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </>
                  ) : (
                    <>
                      {/* <div className={style.returnPickUp}>
                        <div className={style.pickUpTime}>
                          <div className={style.pickUpTimeTitle}>Pick-up time</div>
                          <div className={style.pickUpTimeContent}>
                            {isEditPickUpTime ? (
                              <div className={style.pickUpTimeContentText}>14 Sep (Wednesday), 10:00-12:00</div>
                            ) : (
                              <div className={style.pickUpTimeContentText}>14 Sep (Wednesday), 10:00-12:00</div>
                            )}
                            <div className={style.pickUpTimeContentBtns}>
                              {isEditPickUpTime ? (
                                <>
                                  <div className={`${style.pickUpTimeContentBtn}`} onClick={() => setIsEditPickUpTime(false)}>
                                    Cancel
                                  </div>
                                  <div className={`${style.pickUpTimeContentBtn} ${style.save}`} onClick={() => savePickUp()}>
                                    Save
                                  </div>
                                </>
                              ) : (
                                <div className={`${style.pickUpTimeContentBtn}`} onClick={() => setIsEditPickUpTime(true)}>
                                  Reschedule
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className={style.pickUpAddress}>
                          <div className={style.pickUpAddressTitle}>Pick-up address</div>
                          <div className={style.pickUpAddressContent}>
                            <p className={style.address}>
                              <span className={style.addressName}>Frank Reckard</span>
                              <span className={style.phone}>+44 7786 5590</span>
                            </p>
                            <p className={style.addressDetails}>
                              123 Main Street, Flat 4, The Old Bakery, Bristol, Avon, United Kingdom NG9 2GZ, United Kingdom NG9 2GZUnited Kingdom NG9 2GZ
                            </p>
                          </div>
                        </div>
                      </div> */}
                    </>
                  )}
                </>
              ) : null}
            </div>
          );
        })}

        {/* 取消二次确认弹窗 */}
        <Dialog open={againCancel} onClose={() => setAgainCancel(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{t("afterSales.statusArea.cancelModal.cancelConfirmText")}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <CommonButton variant="outlined" onClick={() => setAgainCancel(false)}>
              {t("afterSales.statusArea.cancelModal.cancelBtnText")}
            </CommonButton>
            <CommonButton variant="contained" onClick={cancelRequestHandler}>
              {t("afterSales.statusArea.cancelModal.confirmBtnText")}
            </CommonButton>
          </DialogActions>
        </Dialog>
        {/* 驿站弹框 */}
        {showLocationModal && (
          <LocationModal
            isOpen={showLocationModal}
            selectValue={curLocationInfo?.postHouseId}
            selectChangeHandler={locationChangeHandler}
            initPostCode={curLocationInfo?.postCode}
            closeHandler={() => {
              setShowLocationModal(false);
            }}
            selectPostCode={curLocationInfo?.postCode || ""}
          />
        )}
        {/* 预览大图弹框 */}
        <ViewImage open={isOpenReviewImage} imageUrl={curStepItem?.qrcode} urlList={[curStepItem?.qrcode]} closeView={() => setIsOpenReviewImage(false)} />
        {/* 物流轨迹弹框 */}
        {showTrackModal && <AfsTrackModal isOpen={showTrackModal} closeHandler={() => setShowTrackModal(false)} />}
      </div>
    );
  }
};

export default AfterSalesAccordion;
